<template>
    <div class="home">
        <div v-if="loading">
            <LiveLogoLoading />
        </div>
        <div class="home-content" v-else>
            <Navbar :siteSetting="siteSetting" />
            <Slider v-if="sliders.length > 0"
                    :sliders="sliders"
                    :rootImagePath="rootImagePath" />

            <ProductCategoreis v-if="productCategoreis.length > 0"
                               :productCategoreis="productCategoreis"
                               :rootImagePath="rootImagePath" />
            <div class="container p-0">
                <Organizations />
                <Shops v-if="topShops.length > 0"
                       :topShops="topShops"
                       :rootImagePath="rootImagePath" />
                <Faq v-if="faqs.length > 0" :faqs="faqs" />
                <Testimonials v-if="testimonials.length > 0"
                              :testimonials="testimonials"
                              :rootImagePath="rootImagePath" />
                <Aboutus />
                <Services v-if="services.length > 0"
                          :services="services"
                          :rootImagePath="rootImagePath" />
                <Blog v-if="blogPosts.length > 0"
                      :blogPosts="blogPosts"
                      :rootImagePath="rootImagePath" />
                <Reports />
                <Contactus :siteSetting="siteSetting" />
                <Social :siteSetting="siteSetting" />
            </div>
            <Footer />
        </div>
    </div>
</template>
<script>
    import store from "@/store";
    import utility from "@/plugins/utility";
    import LiveLogoLoading from "@/components/LiveLogoLoading";
    import Navbar from "./share/Navbar";
    import Slider from "./home/Slider";
    import Aboutus from "./home/Aboutus";
    import Shops from "./home/Shops";
    import Faq from "./home/Faq";
    import Products from "./home/Products";
    import ProductCategoreis from "./home/ProductCategoreis";
    import Organizations from "./home/Organizations";
    import ShopCategories from "./home/ShopCategories";
    import Testimonials from "./home/Testimonials";
    import Reports from "./home/Reports";
    import Services from "./home/Services";
    import Blog from "./home/Blog";
    import Social from "./home/Social";
    import Contactus from "./home/Contactus";
    import Footer from "./share/Footer";

    import "jquery/src/jquery.js";
    import "bootstrap/dist/js/bootstrap.min.js";

    const db = new utility.db();
    export default {
        data()
        {
            return {
                loading: true,
                rootImagePath: "",
                sliders: [],
                faqs: [],
                products: [],
                productCategoreis: [],
                testimonials: [],
                topShops: [],
                services: [],
                blogPosts: [],
                siteSetting: {}
            };
        },

        components: {
            LiveLogoLoading,
            Navbar,
            Slider,
            Aboutus,
            Shops,
            Faq,
            Products,
            ProductCategoreis,
            Organizations,
            ShopCategories,
            Testimonials,
            Reports,
            Services,
            Blog,
            Social,
            Contactus,
            Footer
        },

        beforeMount()
        {
            this.initHome();
        },

        methods: {
            initHome()
            {
                if (db.select("homeData")) this.initData(db.select("homeData"));

                axios({ method: "get", url: "/api/General/GetRamnicData" })
                    .then(response =>
                    {
                        this.initData(response.data);
                    })
                    .catch(error => { });
            },

            initData(obj)
            {
                for (var i = 0; i < obj.topShops.length; i++)
                {
                    obj.topShops[i].answer =
                        obj.topShops[i].answer ?
                        obj.topShops[i].answer.replace(/\n/ig, "<br>\n") : "";
                }

                this.rootImagePath = obj.rootImagePath;
                this.sliders = obj.sliders;
                this.faqs = obj.faqs;
                this.products = obj.products;
                this.productCategoreis = obj.productCategoreis;
                this.testimonials = obj.testimonials;
                this.topShops = obj.topShops;
                this.services = obj.services;
                this.blogPosts = obj.blogPosts;
                this.siteSetting = obj.siteSetting;


                db.insert("homeData", obj);
                this.loading = false;
            }
        }
    };
</script>
<style>
    .home,
    .home-content {
        width: 100%;
        height: auto;
        float: left;
        background: #EAEDED;
    }

    .bg-light {
        background: #fbfbfb !important;
    }

    section {
        width: 100% !important;
        display: block;
        height: auto;
        float: left;
        overflow: hidden;
        padding-top: 20px;
        padding-bottom: 20px;
        margin-bottom: 20px;
    }

    .dropdown-item.active,
    .dropdown-item:active {
        color: #fff;
        text-decoration: none;
        background-color: #fff;
    }

    .link-more {
        display: inline-block;
        min-width: 250px;
        height: 40px;
        border-radius: 10px;
        background: #f5c842;
        color: #292929;
        text-align: center;
        padding: 10px;
        text-decoration: none;
        transition: all 0.5s;
        cursor: pointer;
    }

        .link-more:hover {
            color: #fff;
            background: #f8df93;
            text-decoration: none;
        }

    /*--------------------------------------------------------------
    # Sections General
    --------------------------------------------------------------*/
    .section-title {
        width: 100%;
        text-align: center;
        padding-bottom: 20px;
        padding-right: 10px;
        padding-left: 10px;
    }

        .section-title h2 {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 20px;
            padding-bottom: 20px;
            position: relative;
        }

            .section-title h2::before {
                content: "";
                position: absolute;
                display: block;
                width: 120px;
                height: 1px;
                background: #ddd;
                bottom: 1px;
                left: calc(50% - 60px);
            }

            .section-title h2::after {
                content: "";
                position: absolute;
                display: block;
                width: 40px;
                height: 3px;
                background: #d00918;
                bottom: 0;
                left: calc(50% - 20px);
            }

        .section-title p {
            margin-bottom: 0;
        }

        .section-title.light {
            color: #ddd;
        }

    @media (max-width: 1024px) {
        section {
            margin-bottom: 5px;
        }
    }
</style>
